import { Component, OnInit, Input, Output,EventEmitter, HostListener, AfterViewInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogData } from 'src/app/shared/model/dialog-data';
import { DialogAlertComponent } from 'src/app/shared/components/dialog-alert/dialog-alert.component';
import { CreditCardData } from "../../model/credit-card-data";
import { cssBrands } from '../../constants/cards';
import { PaymentMethodOption } from '../../model/payment-method-option';
import { DtmService } from "../../../services/dtm.service";
import { CustomerPaymentMethod } from "../../model/customer-payment-method";
import { SuggestionMessage }from "../../model/sugestion-message";
import { SessionStorageService } from '../../services/session-storage.service';


@Component({
    selector: 'pme-registered-credit-cards',
    templateUrl: './registered-credit-cards.component.html',
    styleUrls: ['./registered-credit-cards.component.scss'],
    standalone: false
})
export class RegisteredCreditCardsComponent implements OnInit, AfterViewInit {

  @Input() creditCardsData: CreditCardData[];
  @Input() availablePaymentOptions: Array<PaymentMethodOption>;
  @Input() maxLimitCreditCards: boolean;
  @Input() submitting: boolean;
  @Input() hiddenAdobeDtm: boolean;

  @Output() changeCreditCard = new EventEmitter();
  @Output() deleteCreditCard = new EventEmitter();
  @Output() backToBack = new EventEmitter();
  @Output() handleIstallmentsPayment = new EventEmitter();
  @Output() handlePaymentConditionInstallmentsPayment = new EventEmitter();

  @Input() suggestionMessage: SuggestionMessage
  @Input() paymentData: CustomerPaymentMethod;
  @Input() adyenCardError: string;
  @Input() isACreditCardError: boolean

  suggestionMessageSubtitle: string
  isChecked: boolean = false;
  addNewCreditCard: boolean = false;
  selectedRadioButton: string|null;
  selectedOption: string;
  defaultCard: boolean;
  defaultCardSelected: string;
  availableCardsQuantity : number = 0;
  startedCreditCardsData : CreditCardData[];
  selectedPaymentCondition: string | null = null;
  formOpened: boolean = false;
  displaySuggestionMessageFlag: boolean = true;
  displayErrorMessageFlag: boolean = true;
  validCards: CreditCardData[];
  oneClickError: boolean = false;
  removedCards: CreditCardData[];
  isMobile: boolean;
  mobileWidth: number = 830;

  constructor(
    public dialog: MatDialog,
    public dtmService: DtmService,
  ) { }

  ngOnInit(): void {
    this.suggestionMessageSubtitle = this.suggestionMessage.subtitle;
    this.isMobile = window.innerWidth <= this.mobileWidth;
    this.startedCreditCardsData = this.creditCardsData;
    this.validCards = this.getValidCards();
    this.organizeDefaultCard(true);
    this.selectedPaymentCondition = this.availablePaymentOptions[this.availablePaymentOptions.length -1].identifier;
    this.handleIstallments();
  }

  ngAfterViewInit(): void {

  }

  ngOnChanges(changes) {
    if (changes.availablePaymentOptions) { //verifica se as novas opções de parcela contém a previamente selecionada (caso de cupom aplicado)
      const hasPaymentOption = changes.availablePaymentOptions.currentValue ? changes.availablePaymentOptions.currentValue.find(opt => opt.identifier === this.selectedPaymentCondition) : false;

      if (!hasPaymentOption) {
        this.selectedPaymentCondition = null;
      }
      this.selectedPaymentCondition = this.availablePaymentOptions[this.availablePaymentOptions.length -1].identifier;
      this.handleIstallments();
    }


    this.organizeDefaultCard();

    if(this.isACreditCardError){
      let cart = JSON.parse(sessionStorage.getItem('cart'))? JSON.parse(sessionStorage.getItem('cart')) : null;
      this.startedCreditCardsData = this.creditCardsData;
      this.dtmService.productsLoaded([{
              classificationName: cart.product? cart.product.classificationName : null,
              identifier: cart.product? cart.product.identifier : null,
              quantity: 1,
              totalValue: cart.product? cart.totalValue : null,
              merchandising: cart.product? cart.product : null,
            },]);
      if(this.validCards  && this.validCards.length >= 1 && this.displaySuggestionMessageFlag){
        sessionStorage.setItem('creditCardPaymentErrorData', JSON.stringify({
          viewedCreditCardPaymentError: true,
					triggeredSecondaryCardAutoSelectFeature: true
        }));
        this.dtmService.customEventCreditCardPaymentError(["CreditCardPaymentError"], {
          errorTriggeredSecondaryCardAutoSelectFeature : true
        });
      }else{
        sessionStorage.setItem('creditCardPaymentErrorData', JSON.stringify({
          viewedCreditCardPaymentError: true,
					triggeredSecondaryCardAutoSelectFeature: false
        }));
        this.dtmService.customEventCreditCardPaymentError(["CreditCardPaymentError"], {
          errorTriggeredSecondaryCardAutoSelectFeature : false
        });
      }

      this.updateCreditCardsDisplay();
      this.selectNextValidRadioButton();

    }
  }

  @HostListener('window:resize', ['$event'])
    onResize(event) {
      let innerWidth = event.target.innerWidth;
      this.isMobile = innerWidth <= this.mobileWidth;

      if(this.isMobile){
        this.suggestionMessage.subtitle = this.suggestionMessage.subtitle.replace('<br>','');

      }else{
        this.suggestionMessage.subtitle = this.suggestionMessageSubtitle
      }

      }

  checkDisplaySuggestionMessage(){
    this.validCards = this.getValidCards();
    const element = document.getElementById('errorMessage');
    if(this.validCards.length === 1){

      this.displaySuggestionMessageFlag = false;

      if (element) {
        element.style.marginBottom = '31px';
      }
    }else{
      if(element){
        element.style.marginBottom = '';
        this.displaySuggestionMessageFlag = true;
      }

    }


  }

  updateCreditCardsDisplay(){

    const creditCardsDataLengthBeforeFilter = this.creditCardsData.length;
    if(this.paymentData && this.paymentData.sameCard){

      if(this.creditCardsData.length > 1){


        this.creditCardsData = this.creditCardsData.filter(

          card => card.accountPaymentDataId !== this.paymentData.accountPaymentDataId
        );

        if(this.creditCardsData.length === creditCardsDataLengthBeforeFilter){ //compra oneClick com > 1 cartão registrado
          this.removedCards = this.creditCardsData.filter(

            card => card.isDefaultCard === true
          );


          this.creditCardsData = this.creditCardsData.filter(

            card => card.isDefaultCard !== true
          );
        }

        if(this.creditCardsData.length !== creditCardsDataLengthBeforeFilter && this.removedCards && this.removedCards.length === 1){

          this.oneClickError = true;
          this.paymentData.card.brand = this.removedCards[0].brand;
          this.paymentData.card.cardNumber = this.removedCards[0].number
        }

      }else if(this.creditCardsData.length === 1){ //compra oneClick com apenas o cartão padrão registrado
        if(this.creditCardsData.length === creditCardsDataLengthBeforeFilter){

          this.removedCards = this.creditCardsData.filter(

            card => card.isDefaultCard === true
          );
          if(this.removedCards.length === 1){

            this.oneClickError = true;
            this.paymentData.card.brand = this.removedCards[0].brand;
            this.paymentData.card.cardNumber = this.removedCards[0].number
            this.checkDisplaySuggestionMessage()
          }
        }
      }
    }

  }
  handleIstallments () {
    const paymentCondition = this.availablePaymentOptions.find(opt => {return opt.identifier === this.selectedPaymentCondition;});
    this.handleIstallmentsPayment.emit(this.selectedPaymentCondition);
    this.handlePaymentConditionInstallmentsPayment.emit(paymentCondition);
  }

  getBrandCSSMatching(brand: string): string {
      return cssBrands[brand];
  }

  getLastCreditCardvalues(cardNumber): string {
    if (cardNumber) {
      if (cardNumber.indexOf(' ') < 0) {
        return `---- ${cardNumber.slice(-4)}`
      } else {
        const splittedNumber = cardNumber.split(' ');
        return `---- ${splittedNumber[splittedNumber.length - 1]}`;
      }
    }
  }

  organizeDefaultCard(firstExecution?:boolean) {
    const defaultCard = this.creditCardsData?.find(card => card.isDefaultCard && card.situation !=='expired');
    this.creditCardsData.sort(this.sortCreditCards)
    if (defaultCard ) {
      if (!this.defaultCardSelected || this.defaultCardSelected && this.defaultCardSelected === defaultCard.accountPaymentDataId) {
        firstExecution = true;
      }
      this.defaultCardSelected = defaultCard.accountPaymentDataId;
      this.onRadioButtonChange(defaultCard.accountPaymentDataId, firstExecution);
    }
  }

  sortCreditCards(a, b) {
    if (a.isDefaultCard === true && a.situation !== 'expired') {
      return -1; // a deve vir antes de b
    } else if (b.isDefaultCard === true && b.situation !== 'expired') {
      return 1; // b deve vir antes de a
    } else if (a.situation === 'expired' && b.situation !== 'expired') {
      return 1; // b deve vir antes de a
    } else if (b.situation === 'expired' && a.situation !== 'expired') {
      return -1; // a deve vir antes de b
    } else {
      return 0; // A ordem entre a e b permanece inalterada
    }
  }

  onRadioButtonChange(option: string, firstExecution?:boolean) {

    let selectedOption = this.creditCardsData.find(card => card.accountPaymentDataId === option);
    if(selectedOption){
      this.formOpened = false;
    }
    if (!selectedOption  || (selectedOption && selectedOption.situation === 'expired')) {
      this.selectedRadioButton = null;
      return;
    }
    this.selectedRadioButton = option;
    if (!this.hiddenAdobeDtm && !firstExecution) {
      this.dtmService.customClickEvent("Seleção de cartão de crédito salvo");
    }
  }

  onDeleteClick(accountPaymentDataId: string) {
    let data = DialogData.fromPreset("MODAL_DELETE_CREDIT_CARD", {
    });

    let dialogRef = this.dialog.open(DialogAlertComponent, {
      disableClose: true,
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.doDeleteCreditCard) {
        this.deleteCreditCard.emit(accountPaymentDataId);
        this.organizeDefaultCard();
        this.dtmService.customClickEvent("Remoção de cartão de crédito");
      }
    });
  }

  toggleDefaultCard(oldDefaultCardValue) {
    const newDefaultCardValue = !oldDefaultCardValue;
    this.dtmService.customClickEvent("Alteração do valor de 'Definir cartão como padrão para próximas compras'", newDefaultCardValue.toString());
  }

  onAddNewCreditCard() {
    this.formOpened = true;
    this.addNewCreditCard = true;
    this.selectedRadioButton = null;
    this.onRadioButtonChange("");
    this.changeCreditCard.emit();
    this.dtmService.customClickEvent("Adição de novo cartão de crédito");
  }


  selectNextValidRadioButton(){

    if (!this.creditCardsData || this.startedCreditCardsData.length <= 1) {

      return;
    }


    let currentIndex = this.creditCardsData.findIndex(
      card => card.accountPaymentDataId === this.selectedRadioButton
    );
    let nextIndex = (currentIndex + 1) % this.creditCardsData.length;


    while (this.creditCardsData[nextIndex].situation === 'expired') {
      nextIndex = (nextIndex + 1) % this.creditCardsData.length;
      if (nextIndex === currentIndex) {

        return;
      }
    }

    if(this.creditCardsData[nextIndex].accountPaymentDataId !== this.selectedRadioButton){
      this.onRadioButtonChange(this.creditCardsData[nextIndex].accountPaymentDataId, false)
    }

    this.selectedRadioButton = this.creditCardsData[nextIndex].accountPaymentDataId;


  }
  getValidCards(){

    const validCards = this.creditCardsData.filter((card) => card.situation !== "expired");
    this.availableCardsQuantity = validCards.length;

    return validCards;
  }
}
